// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__MASbb","fullWidth":"Input_fullWidth__1hx3P"};